"use client";
import { PrismicNextLink } from "@prismicio/next";
import React from "react";

export default function Cta({
  page,
  padding,
  width,
}) {
  return (
    <PrismicNextLink
      field={page}
      className={
        `cta-text rounded-lg cursor-pointer py-2.5 text-dark-green no-underline
        ${padding} ${width} text-center transition bg-yellow`
      }
    />

  );
}
